"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offsetToPosition = offsetToPosition;
exports.locToRange = locToRange;
exports.Position = exports.Range = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 *  Copyright (c) 2019 GraphQL Contributors
 *  All rights reserved.
 *
 *  This source code is licensed under the license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  
 */


var Range =
/*#__PURE__*/
function () {
  function Range(start, end) {
    var _this = this;

    _classCallCheck(this, Range);

    _defineProperty(this, "start", void 0);

    _defineProperty(this, "end", void 0);

    _defineProperty(this, "containsPosition", function (position) {
      if (_this.start.line === position.line) {
        return _this.start.character <= position.character;
      } else if (_this.end.line === position.line) {
        return _this.end.character >= position.character;
      } else {
        return _this.start.line <= position.line && _this.end.line >= position.line;
      }
    });

    this.start = start;
    this.end = end;
  }

  _createClass(Range, [{
    key: "setStart",
    value: function setStart(line, character) {
      this.start = new Position(line, character);
    }
  }, {
    key: "setEnd",
    value: function setEnd(line, character) {
      this.end = new Position(line, character);
    }
  }]);

  return Range;
}();

exports.Range = Range;

var Position =
/*#__PURE__*/
function () {
  function Position(line, character) {
    var _this2 = this;

    _classCallCheck(this, Position);

    _defineProperty(this, "line", void 0);

    _defineProperty(this, "character", void 0);

    _defineProperty(this, "lessThanOrEqualTo", function (position) {
      return _this2.line < position.line || _this2.line === position.line && _this2.character <= position.character;
    });

    this.line = line;
    this.character = character;
  }

  _createClass(Position, [{
    key: "setLine",
    value: function setLine(line) {
      this.line = line;
    }
  }, {
    key: "setCharacter",
    value: function setCharacter(character) {
      this.character = character;
    }
  }]);

  return Position;
}();

exports.Position = Position;

function offsetToPosition(text, loc) {
  var EOL = '\n';
  var buf = text.slice(0, loc);
  var lines = buf.split(EOL).length - 1;
  var lastLineIndex = buf.lastIndexOf(EOL);
  return new Position(lines, loc - lastLineIndex - 1);
}

function locToRange(text, loc) {
  var start = offsetToPosition(text, loc.start);
  var end = offsetToPosition(text, loc.end);
  return new Range(start, end);
}